import React, { useState, useEffect } from "react";
import { Row, Col, Layout, notification } from "antd";
import UserDrawer from "../../components/drawer/UserDrawer";
import { IndividualConversationStyle } from "../myProfile/IndividualConversationStyle";
import { useNavigate, useLocation } from "react-router-dom";
import "../onboarding/UserOnboardingPage.css";
import "../myProfile/PreviousConversationsStyles";
import myFriendLogo from "../../assets/images/my-friend-logo.png";
import myFriendText from "../../assets/images/my_friend_text.svg";
import goBackButton from "../../assets/images/Go_Back.svg";
import ProfileIcon from "../../assets/images/Drawer_Image.svg";
import welcomeText from "../../assets/images/Ellipse 35.svg";
import logo from "../../assets/images/my-friend-logo.png";
import logo2 from "../../assets/images/my-frieind-logo2.svg";
import './VoiceSelection2.css';
import { getScriptStatus } from "../../api/password";
import { isNull } from "lodash";
import { postRequest } from "../../api";
import amyImage from '../../assets/images/my-friend-logo.png';
import arthurImage from '../../assets/images/my-frieind-logo2.svg';
import samImage from '../../assets/images/Sam_Logo.png';
import { getUserBots } from "../../api/Avatar";

const VoiceSelection2 = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const navigate = useNavigate();
    const [gettingToKnowScriptStatus, setGettingToKnowScriptStatus] = useState(false);
    const location = useLocation();
    const { botName } = location.state || {};
    const { userId } = location.state || {};
    const { Content } = Layout;
    const [responseLoading, setResponseLoading] = useState(true);
    const [selectedVoice2, setSelectedVoice2] = useState(botName || '');
    const [botsData, setBotsData] = useState({});

    const fetchBotsData = async () => {
        try {
            const response = await getUserBots();
            if (response.success) {
                setBotsData(response.data.reduce((acc, { botName, imageUrl }) => {
                    acc[botName] = imageUrl;
                    return acc;
                }, {}));
            }
        } catch (error) {
            console.error('Error fetching bot data:', error);
            notification.error({
                message: 'Error fetching bot data',
                description: error.message,
            });
        }
    };

    useEffect(() => {
        fetchBotsData();
    }, []);

    useEffect(() => {
        checkGettingToKnowYouScriptStatus();
    }, []);

    const checkGettingToKnowYouScriptStatus = async () => {
        try {
            const response = await getScriptStatus();
            if (!isNull(response.conversation)) {
                response?.conversationCompleted && setGettingToKnowScriptStatus(true);
                setResponseLoading(true);
            } else {
                setGettingToKnowScriptStatus(false);
                setResponseLoading(true);
            }
        } catch (err) {
            console.log("In catch", err);
        }
    };

    const openDrawer = () => {
        setIsDrawerOpen(true);
    };

    const closeDrawer = () => {
        setIsDrawerOpen(false);
    };

    const handleGoBackButton = () => {
        navigate("/landing-page");
    };

    function handleConfirm() {
        if (selectedVoice2 === 'Sam') {
            gettingToKnowScriptStatus
                ? navigate("/text-conversation?type=openConversation", { state: { selectedVoice2, userId: userId } })
                : navigate("/text-conversation?type=gettingToKnowYou", { state: { selectedVoice2, userId: userId } });
        } else {
            gettingToKnowScriptStatus
                ? navigate("/conversation?type=openConversation", { state: { selectedVoice2, userId: userId } })
                : navigate("/conversation?type=gettingToKnowYou", { state: { selectedVoice2, userId: userId } });
        }
    }

    const handleVoiceSelection = async (voice) => {
        setSelectedVoice2(voice);

        try {
            const response = await postRequest('/user/choose-avatar', {
                avatar: voice,
            });

            if (response.error) {
                notification.error({
                    message: 'Avatar Error',
                    description: response.error,
                    duration: 10
                });
            } else {
                notification.success({
                    message: 'Avatar Success',
                    description: 'Updated Avatar successfully!',
                    duration: 10
                });
                navigate("/voice-selection2", { state: { selectedVoice: voice } });
            }
        } catch (error) {
            notification.error({
                message: 'API Error',
                description: 'There was an error updating the avatar. Please try again later.',
                duration: 10
            });
        }
    };

    return (
        <>
            <Row className="onboarding-page-section">
                <Col flex="10%" className="go-back-button">
                    <button onClick={handleGoBackButton} className="button-styling">
                        <img src={goBackButton} alt="Go Back Button" />
                    </button>
                </Col>
                <Col flex="80%" className="my-friend-text">
                    <img src={myFriendText} alt="My Friend Text" />
                    <img style={IndividualConversationStyle.logoStyle} src={myFriendLogo} alt="my-friend-logo" />
                </Col>
                <Col flex="10%" className="search-button">
                    <img
                        src={ProfileIcon}
                        alt="Profile Icon"
                        onClick={openDrawer}
                        style={{ cursor: 'pointer' }}
                    />
                    {isDrawerOpen && (
                        <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
                    )}
                </Col>
            </Row>
            <Row justify={"center"}>
                {isDrawerOpen && (
                    <Col span={4}>
                        <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
                    </Col>
                )}
            </Row>
            <div className="voice-section">
                <Content className="content">
                    <Row justify="center" align="middle" className="image-col-main">
                        <Col xs={24} md={12} className="image-col">
                            <div className={`image-container ${selectedVoice2 === 'Amy' ? 'right-side-style' : 'right-side-style2'}`}>
                                <div className="img-relative">
                                    <img src={welcomeText} alt="Welcome Text" className="img-styling " />
                                    <p className="text-style">
                                        Talk to me!
                                    </p>
                                </div>
                                <img src={selectedVoice2 === 'Amy' ? logo : logo2} alt="Talk to me!" className="main-image" />
                            </div>
                        </Col>
                        <div className="voice-selection-container">
                            <h2 className="voice-heading">Choose Your Friend</h2>
                            <p className="voice-desc">
                                Choose between Amy, Arthur or Sam as your Friend. On selecting this will be your default avatar, but remember you can change at any time in settings. Additionally you can also change the speech speed settings under change avatar settings.
                            </p>
                            <div className="voice-card">
                                <div className="voice-cards">
                                    <div className={`voice-option ${selectedVoice2 === 'Amy' ? 'selected' : ''}`} onClick={() => handleVoiceSelection('Amy')}>
                                        <p className="voice-name">Amy - Female Voice</p>
                                        <div>
                                            <img
                                                src={botsData['Amy'] || amyImage}
                                                alt="Amy"
                                                className="voice-image"
                                                style={{ borderRadius: '50%' }}
                                            />
                                        </div>
                                        <button className="voice-button">{selectedVoice2 === 'Amy' ? 'Chosen' : 'Choose'}</button>
                                    </div>
                                    <div className={`voice-option ${selectedVoice2 === 'Arthur' ? 'selected' : ''}`} onClick={() => handleVoiceSelection('Arthur')}>
                                        <p className="voice-name">Arthur - Male Voice</p>
                                        <div>
                                            <img
                                                src={botsData['Arthur'] || arthurImage}
                                                alt="Arthur"
                                                className="voice-image"
                                                style={{ borderRadius: '50%' }}
                                            />
                                        </div>
                                        <button className="voice-button">{selectedVoice2 === 'Arthur' ? 'Chosen' : 'Choose'}</button>
                                    </div>
                                    <div className={`voice-option ${selectedVoice2 === 'Sam' ? 'selected' : ''}`} onClick={() => handleVoiceSelection('Sam')}>
                                        <p className="voice-name">Sam - Text Based</p>
                                        <div>
                                            <img
                                                src={botsData['Sam'] || samImage}
                                                alt="Sam"
                                                className="voice-image"
                                                style={{ borderRadius: '50%' }}
                                            />
                                        </div>
                                        <button className="voice-button">{selectedVoice2 === 'Sam' ? 'Chosen' : 'Choose'}</button>
                                    </div>
                                </div>
                            </div>
                            <button className='voice-confirm-btn' onClick={handleConfirm}>Let's Start</button>

                        </div>
                    </Row>
                </Content>
            </div>
        </>
    );
}

export default VoiceSelection2;
